<div class="contact-us-container">
  <div class="contact-us-form-container">
    <app-business-contact-form
      [events]="formEventSubject"
      (sendMail)="submitContactForm($event)"
      class="contact-us-form"
    ></app-business-contact-form>
  </div>
</div>
